import React from 'react'

const Backend = () => {
  return (
    <div className="skills__content">
        <h3 className="skills__title">Backend</h3>

        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                <i class='bx bxs-chevron-right-circle'></i>
                <div>
                    <h3 className="skills__name">Java</h3>
                    
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bxs-chevron-right-circle'></i>
                <div>
                    <h3 className="skills__name">Python</h3>
                    
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bxs-chevron-right-circle'></i>
                <div>
                    <h3 className="skills__name">ActiveMQ</h3>
                    
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bxs-chevron-right-circle'></i>
                <div>
                    <h3 className="skills__name">Tomcat</h3>
                    
                </div>
                </div>

                

            </div>

            <div className="skills__group">
                
                <div className="skills__data">
                <i class='bx bxs-chevron-right-circle'></i>
                <div>
                    <h3 className="skills__name">REST APIs</h3>
                    
                </div>
                </div>


                <div className="skills__data">
                <i class='bx bxs-chevron-right-circle'></i>
                <div>
                    <h3 className="skills__name">Supabase</h3>
                    
                </div>
                </div>
                
                <div className="skills__data">
                <i class='bx bxs-chevron-right-circle'></i>
                <div>
                    <h3 className="skills__name">Camel</h3>
                    
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bxs-chevron-right-circle'></i>
                <div>
                    <h3 className="skills__name">Postman</h3>
                    
                </div>
                </div>
                

                

            </div>

        </div>
    </div>
  )
}

export default Backend